<template>
  <v-dialog v-model="intDialogVisible" max-width="600px" class="addValueModal addComment">
    <v-card>
      <v-card-title>
        <h3 class="primary--text formName">{{formName}}</h3>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3"  @submit.prevent="submit">
          <v-textarea v-model="customerValue" class="addValueInput"></v-textarea>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close" >
              Close
            </v-btn>
            <v-btn class="addValue" @click="submit" >
              Ask for a new pool
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: Boolean,
    formName: String,
  },
  data () {
    return{
      customerValue:'',
      returnedCustomerValue:'',
    }
  },
  methods:{
    submit(){
      this.returnedCustomerValue = this.customerValue;
      this.customerValue = "";
       this.$emit('newValueIsProposed',this.returnedCustomerValue)
    },
    close(){
        this.$emit('close',false)
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },
  watch: {
    dialogVisible: function(){
      this.customerValue = "";
    }
  }

}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:10px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .formName{
    text-align: left;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
  }
  .addValueModal button{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 7px 18.5px;
    color:#3783C5;
    margin: 5px;
  }

    .addValueModal button.addValue{
      border: 1px solid #3783C5;

      background:#3783C5;
      color:#fff;
    }

    .addValueInput input{
      border: 1px solid #DDDDDD;
    }
  .addComment textarea{
    width: 100%;
margin: 0;
border: 1px solid #DDDDDD;
mask-image: none !important;
  }
  .v-card-title{
    white-space: normal !important;
  }
</style>
